module.exports = __webpack_public_path__ + "static/media/star-fade.003dfbe6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/star-fade.gif
// module id = 576
// module chunks = 0